import React, { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Paper, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// import userflow from 'userflow.js'

import MainLayout from 'layouts/mainLayout'

import GoogleReview from 'components/Common/SocialWidgets/GoogleReview'
import TwitterLiveFeed from 'components/Common/SocialWidgets/TwitterLiveFeed'

import ErrorMessage from 'components/Common/ErrorMessage'
// import IdleTimer from 'components/Common/IdleTimer'

import SubscriptionModal from 'components/Common/Modal/SubscriptionModal'
import ConnectAppModal from 'components/Common/Modal/ConnectAppModal'
import api from 'api'
import actionTypes from 'store/actions'
import ZendeskLink from 'components/Common/ZendeskLink'

const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY'])

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  width: '33%',
  minWidth: '330px',
  [theme.breakpoints.down('md')]: {
    width: '50%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))

function SocialPage(props) {
  const companyId = useSelector(state => state.apiResponseReducers.companyId)
  const errorState = useSelector(state => state.appReducer.errorState)
  const dayspanSelected = useSelector(state => state.appReducer.financialOverviewDaySpan)
  const isModalStepOpen = useSelector(state => state.appReducer.isOpenSubscriptionModal)
  const isCompanyNameModalOpen = useSelector(state => state.appReducer.isOpenCompanyNameModal)
  const user = useSelector(state => state.userReducer.user)
  const dispatch = useDispatch()

  const modalHandler = useCallback(
    value => {
      dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: value })
      dispatch({ type: actionTypes.TOGGLECOMPANYNAMEMODAL, data: value })
    },
    [dispatch],
  )

  useEffect(() => {
    if (!user) return
    const dashboardData = async () => {
      //Todo: Sending dummy company ID untill the feature is implemented
      await api.getDashboardData(companyId, dayspanSelected, 6)
    }

    // userflow.identify(user.id, {
    //   name: `${user.firstName} ${user.lastName}`,
    //   email: user.email,
    //   signed_up_at: new Date(user.accessPeriodEnd).toISOString(),
    // })
    dashboardData()
    // eslint-disable-next-line
  }, [user, companyId])

  const onErrorMessageCloseClick = () => {
    dispatch({ type: actionTypes.SETERRORSTATE, data: false })
  }

  const tiles = [
    {
      tile: <GoogleReview />,
    },
    {
      tile: <TwitterLiveFeed />,
    },
  ]

  return (
    <MainLayout>
      {/* <IdleTimer maxIdleTime={process.env['REACT_APP_MAX_IDLE_TIME_DASHBOARD']} /> */}
      {errorState && <ErrorMessage error={'Something went wrong'} onCloseClick={onErrorMessageCloseClick} />}
      {!errorState && (
        <Box>
          <Box
            container
            spacing={{
              sm: 2,
              md: 2,
              lg: 3,
              xl: 4,
            }}
            sx={{
              gap: '3rem',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'center',
            }}
          >
            {tiles.map((tile, index) => (
              <Item
                key={'socialReview' + index}
                sx={{ borderRadius: 3, padding: 0, boxShadow: '4px 4px 15px rgba(10, 120, 205, 0.08)' }}
              >
                {tile.tile}
              </Item>
            ))}
          </Box>
          <ConnectAppModal isModalOpen={isCompanyNameModalOpen} setModalOpen={modalHandler} />
          <Elements stripe={stripePromise}>
            <SubscriptionModal isModalOpen={isModalStepOpen} setModalOpen={modalHandler} />
          </Elements>
        </Box>
      )}
      <ZendeskLink />
    </MainLayout>
  )
}

export default SocialPage
